export default __webpack_public_path__ + "static/media/tresovsres.331914e2.png";